module.exports = __webpack_public_path__ + "static/img/technologyu03.9c97fb40.png";